/**
 * Класс AbstractImporter
 */
class AbstractImporter {
  parse(data) {

  }

  read(data) {

  }
}

module.exports = AbstractImporter;